<template>
  <vx-card class="mt-base" :title="activityTitle">
    <h4 class="mb-5">Build a basic electric motor.</h4>
    <p class="mb-5">
      Electrical Engineers design all sorts of things that are powered in some way and the basis of
      this will usually be some sort of electric motor. In their most basic form, electric motors
      make use of electrical currents, electrical fields and magnetism to rotate a drive shaft and
      thereby create rotational force to drive machinery.
    </p>
    <p class="mb-5">
      First, let’s look at how this actually happens. Have a look at the following video:
    </p>
    <responsive-youtube-wrapper :video="videos[1].video" :image="videos[1].image" />

    <p class="mb-5">
      Now, let’s take these principles and use them to build a very basic electric motor.
    </p>
    <h4 class="mb-5">Your Task:</h4>
    <p class="mb-5">
      To use the materials outlined below and the instructional video (you can start it, stop it and
      replay sections as much as you need to) to build the electric motor. There is also a set of
      printable instructions to work with if you need them.
    </p>
    <div class="vx-row mb-5">
      <div class="vx-col lg:w-1/2">
        <h4 class="mb-5"><u>Materials required:</u></h4>
        <ul class="default-list">
          <li>1 “D” Cell battery</li>
          <li>Copper wire</li>
          <li>Large paperclips</li>
          <li>Electrical tape</li>
          <li>Marker pen (for winding the copper wire)</li>
          <li>2 small magnets</li>
          <li>Fine grit sandpaper</li>
          <li>Scissors</li>
        </ul>
      </div>
      <div class="vx-col lg:w-1/2">
        <responsive-iframe-youtube :src="video.url" :posterimg="video.image" />
        <a :href="'content/engineering/electric_motor_instructions.pdf' | blob_url" target="_blank">
          <centered-image-wrapper
            alt="Electric motor instructions (PDF) (opens in a new tab)"
            :image="require('@/assets/images/experiences/engineering/instruction_sheet_button.png')"
            classes="3/3"
          />
        </a>
      </div>
    </div>

    <p class="mb-5">Finished?</p>
    <p class="mb-5">
      Once you have completed your electric motor, take a video of it running and upload it below.
    </p>
    <fileupload-button-immediate
      v-model="uploaded_files['uploaded_file_1']"
      :is-editable="isEditable"
      filetype="video"
      upload-btn-text="Upload Video"
    />

    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
export default {
  data() {
    return {
      videos: {
        1: {
          image: require('@/assets/images/experiences/engineering/how_electric_motor_work_splash.jpg'),
          video: 'https://www.youtube.com/embed/CWulQ1ZSE3c',
        },
      },
      uploaded_files: {
        uploaded_file_1: '',
      },
    };
  },
  methods: methods,
  computed: {
    ...computed,
    video() {
      return {
        url: 'https://www.youtube.com/embed/WI0pGk0MMhg',
        image: require('@/assets/images/experiences/engineering/instruction_video_trigger.jpg'),
      };
    },
  },
  inject: inject,
  mounted() {
    for (let i = 1; i <= 1; i++) {
      if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
        this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
      }
    }
  },
};
</script>
